jQuery(function($){
    fillCart = function(data){
        if(data.purchase_type == 'amount'){

            var productTitle = "Amount";
            var finalPrice = parseFloat(data.total);

            var finalPrice = finalPrice.toFixed(2);
            var mainCartItemText = productTitle + " - $" + finalPrice;

            var finalText = '<h4 class="cartItemTitle" data-item-total="'+finalPrice+'">'+mainCartItemText+'</h4></div>';

            $('.divCartContent').append('<div class="cartItems" data-product-id="0">'+finalText+'</div>');
        }else if(data.purchase_type == 'treatment'){
            data.treatments = data.treatments;
            if(!$.isArray(data.treatments)){
                return false;
            }
            data.treatments.forEach(function(treatment){
                var productId = treatment.id;
                var productTitle = treatment.title;
                var productPrice = parseFloat(treatment.price);
                var addOnPrice = 0; 
                var addonCartItemText = '';

                if($.isArray(treatment.addons)){
                    treatment.addons.forEach(function(addon){
                        addonCartItemText += '<span class="addonItem">'+addon.title+'</span>';
                        addOnPrice += parseFloat(addon.price);
                    });
                }

                var finalPrice = (productPrice + addOnPrice).toFixed(2);
                
                var finalText = '<h4 class="cartItemTitle" data-item-total="'+finalPrice+'">';
                if($('body').hasClass('certificate')){
                    productTitle = '<i class="fa fa-edit editItem"></i>'+productTitle;
                }
                
                finalText += '<span class="cartItemLeft">'+productTitle+'</span><span class="cartItemRight">$'+finalPrice+'</span>';
                finalText += '</h4><div class="cartItemAddons">'+addonCartItemText+'</div></div>';

                $('.divCartContent').append('<div class="cartItems" data-product-id="'+productId+'">'+finalText+'</div>');  
            });
            updateGratuity(data.gratuity);
        }
        updateCartTotal();
    }

    updateGratuity = function(gratuity){
        $('.cartItems[data-product-id=99999]').remove();
        if(gratuity > 0){
            var finalText = '<h4 class="cartItemTitle" data-item-total="'+gratuity+'">';
            finalText += '<span class="cartItemLeft">Gratuity ('+gratuity+'%)</span><span class="cartItemRight" id="gratuitycartamt"></span>';
            finalText += '</h4></div>';
            $('.divCartContent').append('<div class="cartItems" data-product-id="99999">'+finalText+'</div>');   
        }
    }

    updateMethod = function(shipping, title){
        $('.cartItems[data-product-id=99998]').remove();
        var finalText = '<h4 class="cartItemTitle" data-item-total="'+shipping+'">';
        finalText += '<span class="cartItemLeft">Shipping ('+title+')</span><span class="cartItemRight">$'+shipping+'</span>';
        finalText += '</h4></div>';
        $('.divCartContent').append('<div class="cartItems" data-product-id="99998">'+finalText+'</div>');   
    }

    updateCartTotal = function(){
        var total = 0;
        var gratuity = 0;
        $('.cartItemTitle').each(function(){
            if($(this).parents('.cartItems').data('product-id') != "99999"){
                total += parseFloat($(this).data('item-total'));
            }else{
                gratuity = parseFloat($(this).data('item-total'));
            }
        });
        var gratuitycartamt = total*(gratuity)/100;
        total += gratuitycartamt;
        gratuitycartamt = gratuitycartamt.toFixed(2);
        total = total.toFixed(2);
        $('#gratuitycartamt').text('$'+gratuitycartamt);
        $('#cartTotal span').text('$'+total);
        $('#total_amount').val(total);

        if($('.divCartContent .cartItems').length > 0){
            $('.no-items').hide();
        }else{
            $('.no-items').show();
        }
    }

    function cartDisplay(){
        var winWidth = $(window).width();
        
        if(winWidth > 991){
            $('.divCartParent').show();
            $('.shoppingCart').remove();

        }else{
            $('.divCartParent').hide();
            $('.navbar-header a.shoppingCart').remove();
            $('.navbar-header').append('<a class="shoppingCart visible-sm visible-xs"><i class="fa fa-shopping-cart"></i></a>');
            $('.shoppingCart').click(function(){
                $('.divCartParent').slideToggle();
            });
        }

        
    }

    $(window).scroll(function() {
        var scrollPos = $(window).scrollTop();
        var cartTopPos = $(".siteHeader").height();
        if(scrollPos > 40){
            $('.divCartParent').css("top", cartTopPos + 10 );
        } else if (scrollPos == 0){
            $('.divCartParent').css("top", 170);
        }
    });
        

    $(document).ready(function(){
        cartDisplay();
        if(typeof(cartData) != 'undefined')
            fillCart(cartData);
        $('.divCartParent').css("top", 170);
    });

    $(window).resize(function(){
    	cartDisplay();
    });
});


// WEBPACK FOOTER //
// ./resources/assets/js/minicart.js